import React from 'react'

function ImageCreatorBackdrop() {
    return (
        <div className='backdrop'></div>
    )
}

export default ImageCreatorBackdrop